export const GET_JOB_DETAILS = 'get_job_details';

export const APPLY_FOR_JOB = 'apply_for_job';

export const GET_MY_JOBS = 'get_my_jobs';

export const GET_APPLICATION_HISTORY = 'get_application_history';

export const VALIDATE_USER = 'validate_user';

export const WFH_FILTER = 'wfh_filter';

// export const PHONE_VERIFICATION = 'phone_verification';
// export const GET_PROFILE = 'get_profile';

export const GET_OFFICE_WORKBOARD_DETAILS = 'get_office_workboard_details';

export const SHOW_TOAST = 'show_toast';

export const HIDE_TOAST = 'hide_toast';

export const APPLICATION_HISTORY = 'application_history';

export const CAMPUS_AMBASSADOR = 'campus_ambassador';

export const CA_TASKS = 'ca_tasks';

export const CA_REFERRALS = 'ca_referrals';

export const CA_REFERRALS_DETAILS = 'ca_referrals_details';

export const GET_ALL_APPLIED_JOBS = 'get_all_applied_jobs';

export const ADD_REFERRAL_CODE = 'add_referral_code';

export const REMOVE_REFERRAL_CODE = 'remove_referral_code';

export const GOOGLE_MAPS_SCRIPT = 'google_maps_script';

export const CAREERS = 'careers';

export const ADD_REDIRECT_URL = 'add_redirect_url';

export const REMOVE_REDIRECT_URL = 'remove_redirect_url';

export const GET_FAQS = 'get_faqs';

export const PROJECT = 'project';

export const OFFER_LETTER = 'offer_letter';

export const FAQS = 'FAQS';

export const EXECUTION_DETAILS = 'execution_details';

export const BANNER_DETAILS = 'banner_details';

export const VACANCY_DETAILS = 'vacancy_details';

export const PROFILE_QUESTIONS = 'profile_questions';

export const PROFILE_ATTRIBUTES = 'profile_attributes';

export const PROFILE_ANSWERS = 'profile_answers';

export const NOTIFICATIONS = 'notifications';

export const CATEGORIES = 'categories';

export const CATEGORY_DETAILS = 'category_details';

export const CATEGORY_APPLICATIONS = 'category_applications';

export const APPLIED_CATEGORIES = 'applied_categories';

export const APPLIED_FOR_CATEGORY = 'applied_for_category';

export const GET_APPLICATION_DETAILS = 'get_application_details';

export const GET_JOBS_BY_CATEGORY = 'get_jobs_by_category';

export const FETCH_APPLICATION_DETAILS = 'fetch_application_details';

export const APPLICATION_PROCESS_FLOW = 'application_process_flow';

export const APPLICATION_RESOURCES = 'application_resources';

export const TELEPHONIC_INTERVIEW_SLOTS = 'telephonic_interview_slots';

export const WEBINAR_TRAINING_SLOTS = 'webinar_training_slots';

export const PROFILE_NUDGES = 'profile_nudges';

export const COURSES = 'courses';

export const REFERRALS = 'referrals';

export const REFERRAL_DETAILS = 'referral_details';

export const HELP = 'help';

export const COMPLETE_PROFILE = 'complete_profile';

export const DREAM_APPLICATION = 'dream_application';

export const OBJECTIVES = 'objectives';

export const WORK_REQUIREMENT = 'work_requirement';

export const ALL_REQUIREMENTS = 'all_requirements';

export const MY_REQUIREMENTS_ANALYSE = 'my_requirements_analyse';

export const REQUIREMENTS_ANALYSE = 'requirements_analyse';

export const WORK_ORDERS = 'work_orders';

export const MY_WORK_ORDERS = 'my_work_orders';

export const WORK_ORDER = 'work_order';

export const WORK_REPORTS = 'work_reports';

export const WORK_REPORT = 'work_report';

export const WORK_REPORTS_ANALYSE = 'work_reports_analyse';

export const WORK_ORDERS_ANALYSE = 'work_orders_analyse';

export const MY_INVOICES = 'my_invoices';

export const INVOICE = 'invoice';

// AE store types

export const PHONE_VERIFICATION = 'phone_verification';

export const OTP_VERIFICATION = 'otp_verification';

export const GET_PROFILE = 'get_profile';

export const EDIT_PROFILE = 'edit_profile';

export const GET_ALL_JOBS = 'get_all_jobs';

export const JOB_DETAIL = 'job_detail';

export const SEARCH_JOBS = 'search_jobs';

export const SAVE_JOB = 'save_job';

export const SAVED_JOBS_LIST = 'saved_jobs_list';

export const APPLY_JOB = 'apply_job';

export const APPLIED_JOBS_LIST = 'applied_jobs_list';

export const MY_REFERRALS = 'my_referrals';

export const SALARY = 'salary';

export const SEARCH_BODY = 'search_body';

export const PARSE_RESUME = 'parse_resume';

export const REGISTER_VENDOR = 'register_vendor';

export const ASSESSMENT_QUES = 'assessment_ques';

export const SUBMIT_ASSESSMENT = 'submit_assessment';

export const CANDIDATE_PROJECTS = 'candidate_projects';

export const ACTIVITY_LOGS = 'activity_logs';

export const TIMESHEETS = 'timesheets';

export const SELECTED_TIMESHEET = 'selected_timesheet';

export const PAYMENTS = 'payments';

export const ATTENDANCE_ENTRIES = 'attendance_entries';

// admin section

export const ADMIN_TIMESHEETS = 'admin_timesheets';

export const ADMIN_TIMESHEET = 'admin_timesheet';

export const ADMIN_ATTENDANCE_ENTRIES = 'admin_attendance_entries';

export const CANDIDATE_PROFILE = 'candidate_profile';

export const ADMIN_CP_LIST = 'admin_cp_list';

export const ADMIN_CREATED_CP = 'admin_created_cp';

export const ADMIN_CANDIDATE_PROJECT = 'admin_candidate_project';

export const ADMIN_REPORTS = 'admin_reports';

export const ADMIN_FINANCE_PAYMENTS = 'admin_finance_payments';

export const ADMIN_APPLICATIONS = 'admin_applications';

export const ADMIN_APPLICATION = 'admin_application';

export const ADMIN_JOBS = 'admin_jobs';

export const ADMIN_JOB = 'admin_job';
